import { Page, Tabs } from '@dixa/lib-shared-habla';
import { useState } from 'react';

import { BannedIpsTab } from './bannedIpsComponents/bannedIpsTab';
import { BannedUsersTab } from './bannedUsersComponents/bannedUsersTab';

enum BanTabs {
  UserBansTab = 'Users',
  IPBansTab = 'IP addresses',
}

const tabsDefinition = Object.values(BanTabs).map((tabName) => ({
  id: tabName,
  label: tabName,
}));

export function Bans(): JSX.Element {
  const [activeTab, setActiveTab] = useState(BanTabs.UserBansTab);

  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId as BanTabs);
  };

  return (
    <>
      <Page.Tabs>
        <Tabs
          selectedId={activeTab}
          tabs={tabsDefinition}
          onChange={handleTabChange}
        />
      </Page.Tabs>

      <Page.Body>
        {activeTab === BanTabs.UserBansTab && <BannedUsersTab />}
        {activeTab === BanTabs.IPBansTab && <BannedIpsTab />}
      </Page.Body>
    </>
  );
}
